import { render, staticRenderFns } from "./Relations.vue?vue&type=template&id=de79c25c&scoped=true"
import script from "./Relations.vue?vue&type=script&lang=js"
export * from "./Relations.vue?vue&type=script&lang=js"
import style0 from "./Relations.vue?vue&type=style&index=0&id=de79c25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de79c25c",
  null
  
)

export default component.exports